<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Block Student Icard</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br>
       <v-row justify="center" dense>
                   <v-col sm="5" md="5">
                    <v-autocomplete class="no-display" :items="students_list" item-value="lid" item-text="name" v-model="students" label="Select Students" dense rounded  multiple outlined color="#0F2027"></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="students.length>0">
                    <v-btn class="info" @click="blockStudentIcard()">Block Icard</v-btn>
                </v-col>
            </v-row>
            
       </v-card>

     <v-card class="box" v-if="blocked_icard_list!=''">
     <v-data-table  :headers="headers" :items="blocked_icard_list" :search="search" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Blocked Icard List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
             <v-text-field v-model="search" append-icon="search" label="Search" rounded background-color="white" color="white" hide-details></v-text-field>
            </v-toolbar>
        </template>
         <template v-slot:[`item.block_idcard`]="{ item }">
            <v-switch color="brand"
            v-model="item.block_idcard"
            @change="saveBlockUnBlockStudentIcard(item)"
            ></v-switch>
          </template>
     </v-data-table>
 </v-card>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      search:"",
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      students_list:[],
      blocked_icard_list:[],
      students:[],
      total_students:[],
      headers:[
      { text: "Name", value: "name" },
      { text: "Is Blocked?", value: "block_idcard" },
      ],
  }),
   methods: {
    saveBlockUnBlockStudentIcard(item){
                const data = {
                    student: item.lid,
                    block_idcard: item.block_idcard,
                };
                this.overlay = true;
                axios
                    .post("/icard/saveBlockUnBlockStudentIcard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                             this.blocked_icard_list = res.data.blocked_icard_list;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
    blockStudentIcard(){
                //  for (var i = 0; i < this.students.length; i++) {
                //     this.total_students.push(this.students[i].lid);
                // }
                // if (this.students.length <= 0) {
                //     this.showSnackbar("#b71c1c", "Please select Students!"); // show snackbar
                // }
               
          const data = {
                    students: this.students
                };
                this.overlay = true;
                axios
                    .post("/icard/saveBlockStudentIcard", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                             this.blocked_icard_list = res.data.blocked_icard_list;
                            this.showSnackbar("green", "Updated Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
    },
   onload() {
        this.overlay = true;
        axios
            .post("/icard/getAllStudents")
            .then((res) => {
                if (res.data.msg == "200") {
                    this.students_list = res.data.students_list;
                    this.blocked_icard_list = res.data.blocked_icard_list;
                } else {
                    alert("Somthing went wrong!!!");
                }
            })
            .catch((error) => {
                alert("Somthing went wrong!!!");
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onload();
  },
  watch: {},
};
</script>
<style scoped>
</style>